import React from 'react'

import { SUI, Tooltip } from 'shared/ui'
import { snooze as SnoozeIcon } from 'assets/icons/groove/v2'
import { snoozeLabel } from 'util/snooze'

import SnoozeDropdown from 'components/App/DesktopView/shared/Snooze/Dropdown'

const SnoozeButton = React.memo(
  ({
    snoozeOpen,
    isSnoozed,
    onSnoozeIconClick,
    onSnoozeDropdownClose,
    onSnoozeOptionClick,
    snoozedUntil,
  }) => {
    const snoozeIcon = (
      <SnoozeIcon id="snoozeIcon" className={isSnoozed ? 'snoozed' : null} />
    )
    return (
      <div className="snooze">
        {!snoozeOpen && (
          <a
            className="menu-button"
            id="snoozeDropdown"
            onClick={onSnoozeIconClick}
          >
            {isSnoozed && (
              <Tooltip
                position="bottom"
                tooltip={`Unsnooze (${snoozeLabel(snoozedUntil)}) [s]`}
              >
                {snoozeIcon}
              </Tooltip>
            )}

            {!isSnoozed && (
              <Tooltip position="bottom" tooltip={`Snooze [s]`}>
                {snoozeIcon}
              </Tooltip>
            )}
          </a>
        )}
        {snoozeOpen && (
          <React.Fragment>
            <a className="menu-button">
              <div className="hack-tooltip-wrapper">{snoozeIcon}</div>
            </a>

            <SUI>
              <SnoozeDropdown
                open
                onClose={onSnoozeDropdownClose}
                onOptionClick={onSnoozeOptionClick}
                hotkey="s"
                id="snoozeDropdown"
                icon={null}
              />
            </SUI>
          </React.Fragment>
        )}
      </div>
    )
  }
)

export default SnoozeButton
